export default defineNuxtRouteMiddleware(async (to, from) => {
  const communityClient = useCommunity()
  const countryId = useCookie(COUNTRY_COOKIE_KEY).value
  const locale = useLocale()
  await communityClient.getHomeContent(locale,countryId)
  await communityClient.getArticleCategories('en',countryId)
  await communityClient.getArticleCategories('es',countryId)
})
